import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '../../../../../types/product.js';
import { isRxProductAction } from '../../../../../types/typeguards.js';
import { getProductTealiumDescription } from '../../../../../utils/get-product-tealium-description.js';
import { useEcommFacetContext } from '../../../context/EcommFacetContext.js';
import { NonRxProductCTA } from '../NonRxProductCTA/NonRxProductCTA.js';
import { RxGlassesCTA } from '../RxGlassesCTA/RxGlassesCTA.js';

const ProductDetailCTA = ({ action , handleConfiguratorOpen , handleConversionEvent , addToCartConfig  })=>{
    const { bookAppointmentRouteConfig , routes , product , activeVariant  } = useProductData();
    const { getLabel  } = useIntl();
    const { isValid , setNotificationType  } = useEcommFacetContext();
    const triggerAlertMessage = React.useCallback(()=>{
        setNotificationType('error');
    }, [
        setNotificationType
    ]);
    /**
   * This is a dummy button that triggers an error message if
   * the add-to-cart flow is not yet valid (i.e. the user still needs to pick a size)
   */ if (!isValid) return /*#__PURE__*/ React.createElement(Button, {
        onClick: triggerAlertMessage,
        caption: getLabel('products.actions.addToCart')
    });
    if (isRxProductAction(action)) return /*#__PURE__*/ React.createElement(RxGlassesCTA, {
        action: action,
        handleConversionEvent: handleConversionEvent,
        onClickWhenOrderable: handleConfiguratorOpen,
        bookAppointmentRouteConfig: bookAppointmentRouteConfig
    });
    var _stores;
    return /*#__PURE__*/ React.createElement(NonRxProductCTA, {
        storesRoute: (_stores = routes.stores) !== null && _stores !== void 0 ? _stores : '',
        action: action,
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: addToCartConfig,
        "data-element-id": "Prod_AddCart",
        "data-description": getProductTealiumDescription(product.name, activeVariant.sku)
    });
};

export { ProductDetailCTA };
//# sourceMappingURL=ProductDetailCTA.js.map
